/**
 * 매물 관련 공통 상수
 * SaleModel.js (re.disco.www) 기준
 */

/** 부동산 종류 (e_rand_type) */
export const E_RAND_TYPES = [
  { value: 16, estate_type: 1, label: '토지' },
  { value: 12, estate_type: 5, label: '상업용건물' },
  { value: 10, estate_type: 7, label: '상가점포' },
  { value: 11, estate_type: 7, label: '사무실' },
  { value: 2, estate_type: 4, label: '오피스텔' },
  { value: 17, estate_type: 8, label: '공장' },
  { value: 19, estate_type: 8, label: '창고' },
  { value: 18, estate_type: 8, label: '지식산업센터' },
  { value: 15, estate_type: 12, label: '숙박시설' },
  { value: 0, estate_type: 3, label: '아파트' },
  { value: 1, estate_type: 3, label: '주상복합' },
  { value: 7, estate_type: 2, label: '연립' },
  { value: 8, estate_type: 2, label: '다세대' },
  { value: 3, estate_type: 0, label: '단독' },
  { value: 4, estate_type: 0, label: '다가구' },
  { value: 6, estate_type: 0, label: '상가주택' },
  { value: 5, estate_type: 0, label: '전원주택' },
  { value: 14, estate_type: 5, label: '기타건물' },
  { value: 20, estate_type: 4, label: '생활숙박시설' },
];

/** e_rand_type → 라벨 빠른 조회 */
export const E_RAND_TYPE_LABEL = Object.fromEntries(
  E_RAND_TYPES.map(t => [t.value, t.label])
);

/** 거래유형 (deal_type) */
export const DEAL_TYPE_NAMES = ['매매', '전세', '월세'];
